import { Collection } from '@msw/data'
import { persist } from '@msw/data/extensions/persist'
import { transferResponseWithUserInfoSchema } from 'app/src/msw/moneytransfer/schemas/transfer'
import type { TransferResponseWithUserInfo } from 'app/src/services/welfareportal/moneytransfer-api'

export const transfersCollection = new Collection({
  schema: transferResponseWithUserInfoSchema,
  extensions: [persist()],
})

export const createTransferSeed = async (overrides?: { firstName?: string; lastName?: string; email?: string }) => {
  try {
    console.log('########## MSW: START TRANSFER SEED ##########')
    const existingData = transfersCollection.findMany()

    console.log('MSW: Checking existing transfer data, found', existingData.length)

    if (existingData.length > 0) {
      return
    }

    const jsonData = await (await fetch('./data/moneyTransfer/transfers.json')).json()

    await Promise.all(
      jsonData.items.map(async (transfer: TransferResponseWithUserInfo) => {
        try {
          if (overrides?.firstName && transfer.userInfo.firstName) {
            transfer.userInfo.firstName = overrides.firstName
          }
          if (overrides?.lastName && transfer.userInfo.lastName) {
            transfer.userInfo.lastName = overrides.lastName
          }
          if (overrides?.email && transfer.userInfo.email) {
            transfer.userInfo.email = overrides.email
          }
          await transfersCollection.create(transfer)
        } catch (error) {
          console.error('MSW: Error creating transfer for id: ', transfer.id, error)
        }
      }),
    )
    console.log('MSW: Seeding transfer data')
  } catch (error) {
    console.error('MSW: Error seeding transfer data', error)
  } finally {
    console.log('########## MSW: END TRANSFER SEED ##########')
  }
}

export const clearTransfersSeed = async () => {
  transfersCollection.clear()
}
